class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.predictiveSearchResults = document.querySelector("#predictive-search");
    this.articlesList = document.querySelector("#articles-list");
    this.articlesListSecond = document.querySelector("#articles-list-second");
    this.paginationContainer = document.querySelector("#pagination-container");
    this.noFoundMessage = document.querySelector(".no-found-message");
    if (this.getAttribute("type") === "mobile") {
      this.form.addEventListener(
        "submit",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    } else {
      this.input.addEventListener(
        "input",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    console.log(searchTerm);
    fetch(
      `/search/suggest?q=${searchTerm}&section_id=read-main&resources[type]=article`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#predictive-search-results").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.clearTagged();
        const width = screen.width;
        if (width < 768) {
          window.location = "#results-parent";
        }
        if (!!resultsMarkup) {
          this.open();
        } else {
          this.close();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  clearTagged() {
    const activeTag = document.querySelector(".active-blog-tag");
    activeTag?.classList?.remove("underline");
    activeTag?.classList?.remove("active-blog-tag");
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.pathname = url.pathname.replace(/\/tagged\/[^\/]+/, "");
    window.history.replaceState(null, "", url.toString());
  }

  open() {
    this.predictiveSearchResults.style.display = "grid";
    this.articlesList.style.display = "none";
    this.articlesListSecond.style.display = "none";
    this.noFoundMessage.classList.add("hidden");
    if (this.paginationContainer)
      this.paginationContainer.style.display = "none";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    this.articlesList.style.display = "none";
    this.articlesListSecond.style.display = "none";
    this.noFoundMessage.classList.remove("hidden");
    if (this.paginationContainer)
      this.paginationContainer.style.display = "block";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
